<template>
  <a-entity
    class="Captation"
    :class="'is-' + captation.name"
    look-at=".Camera"
    :id="'Captation__' + captation.name"
    :position="inlinePosition(captation.position)">

    <a-plane
      class="Fuse"
      transparent="true"
      opacity="0"
      :width="width / 2"
      :height="height / 2"
      position="0 0 .001"
      v-if="fuse && !$route.params.captation"
      @click="$router.push({ name: 'captation.' + lang, params: { captation: captation.name, level: captation.level }})"
    />

    <a-image
      v-if="$route.params.captation == captation.name || bgLoaded"
      :src="captation.img.full"
      :width="width"
      :height="height"
      transparent="true"
      opacity="0"
      ref="bg"
      position="0 0 -.01"
      material="shader: flat; side: front;"
      @materialtextureloaded="bgISLoaded"
    />

    <a-entity scale="0 0 0" ref="play_pause" v-if="vr || $root.$agent.mobile" position="1.95 .2 .1">
      <PlayPause size=".3" />
    </a-entity>
    <a-entity scale="0 0 0" ref="skip" v-if="vr || $root.$agent.mobile" position="1.95 -.2 .1">
      <Skip size=".3" />
    </a-entity>

    <a-image
      :src="captation.img.silhouette"
      :width="width"
      :height="height"
      ref="silhouette"
      opacity="0"
      transparent="true"
      material="shader: flat; side: front"
      @materialtextureloaded="silhouetteISLoaded"
    />

  </a-entity>
</template>

<script>
import Settings from '@/config/Settings'
import Skip from '@/components/skip/Skip'
import PlayPause from '@/components/play_pause/PlayPause'

export default {
  name: 'Captation',
  props: ['captation'],
  components: { PlayPause, Skip },
  data: () => ({
    width: 3.5,
    height: 3.5,
    fuse: false,
    silhouetteImgLoaded: false,
    silhouetteLoaded: false,
    bgLoaded: false,
    bgImgLoaded: false,
  }),
  watch: {
    '$route': 'checkRoute'
  },
  created() {
  },
  beforeDestroy() {
    THREE.Cache.remove(this.captation.img.full)
    THREE.Cache.remove(this.captation.img.silhouette)
    TweenLite.killTweensOf(this.$refs.silhouette)
    TweenLite.killTweensOf(this.$refs.bg)
    TweenLite.killTweensOf(this.$el)
    if(this.$refs.skip && this.$refs.play_pause) {
      TweenLite.killTweensOf(this.$refs.skip)
      TweenLite.killTweensOf(this.$refs.play_pause)
    }
  },
  methods: {
    checkRoute() {
      if(this.$route.params.captation == this.captation.name) {
        this.captation.viewed = false
        return this.switchToBg()
      }

      if(this.$route.meta.name == 'explorer')
        return this.showSilhouette()

      if(this.$route.meta.name == 'level' && this.captation.level == this.$route.params.level)
        return this.showSilhouette()

      if(this.$route.meta.name == 'captation' && this.captation.level == this.$route.params.level)
        return this.showSilhouette()

      this.leave()
    },
    bgISLoaded(e) {
      e.target.object3DMap.mesh.material.depthTest = false
      this.bgLoaded = true
    },
    silhouetteISLoaded(e) {
      e.target.object3DMap.mesh.material.depthWrite = false
      this.silhouetteLoaded = true
      this.checkRoute()
    },
    switchToBg() {
      if(!this.bgLoaded)
        return this.$unWatchBg = this.$watch('bgLoaded', this.switchToBg)

      if(this.$unWatchBg)
        this.$unWatchBg()

      this.captation.clicked = true

      TweenLite.to(this.$refs.silhouette, 3, { delay: 2, aframe: { alpha: 0 } })
      TweenLite.to(this.$el, 20, { delay: 2, aframe: { y: 2 } })
      TweenLite.to(this.$refs.bg, 15, { delay: 2, aframe: { alpha: 1 },
        onStart: () => { if(this.$route.params.captation != this.captation.name) this.leave() },
        onComplete: () => { if(this.$route.params.captation != this.captation.name) this.leave() }
      })
      if(this.$refs.skip && this.$refs.play_pause)
        TweenLite.to([this.$refs.skip, this.$refs.play_pause], 1, { delay: 2, aframe: { scale: 1 }})
    },
    showSilhouette() {
      if(this.captation.viewed) return

      if(this.captation.clicked)
        return this.leave()

      const routeName = this.$route.meta.name
      this.captation.isShow = true

      //
      // todo filter by distance
      const count = _.size(_.filter(this.captations, c => c.isShow == true))

      if(count > 10)
        return
      //

      if(!this.silhouetteLoaded)
        return this.$unWatchsilhouette = this.$watch('silhouetteLoaded', this.showSilhouette)

      if(this.$unWatchsilhouette)
        this.$unWatchsilhouette()

      if(routeName == 'captation' || routeName == 'explorer')
        TweenLite.delayedCall(2, () => this.fuse =  true)

      TweenLite.to(this.$refs.silhouette,
        routeName == 'level' ? 20 : 2, {
          aframe: {
            alpha: routeName == 'level' ? .2 : 1,
          }
        })
    },
    leave() {
      if(this.$refs.skip && this.$refs.play_pause)
        TweenLite.to([this.$refs.skip, this.$refs.play_pause], 1, { aframe: { scale: 0 }})

      this.captation.isShow = false
      this.fuse = false

      TweenLite.to([this.$refs.silhouette, this.$refs.bg], 1, { aframe: { alpha: 0 }, onComplete: () => {
        if(this.captation.clicked)
          this.captation.viewed = true
      }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/captation/Captation.vue